import moment from 'moment';

//todo: the following data sets have not been tested:
// elevator permit
// board of standards and appeals
// dob sign applications
// boilers
// hpd complaints
// hpd repair/vacate

// Default display format (e.g. 9/9/2026). Pass a `format` prop on the column
// config to override per-column, e.g. 'MMM D, YYYY' for "Sep 9, 2026".
const DEFAULT_FORMAT = 'M/D/YYYY';

function DateFormatter(props) {
	let { text, format = DEFAULT_FORMAT } = props;
	let date;

	// Treat missing, empty, or all-zero dates as blank
	if (!text || text === '0000-00-00' || text === '0000-00-00T00:00:00.000Z') {
		return <span title={text}>–</span>;
	}

	if (typeof text === 'number') {
		// Epoch seconds
		date = moment.unix(text);
	} else if (/^\d{8}$/.test(text)) {
		//some are formatted like `20201213`, which is 12/13/2020
		//open data dob violations and open data ecb violations are like this
		date = moment(text, 'YYYYMMDD');
	} else if (/^\d{4}-\d{2}-\d{2}$/.test(text)) {
		// Date-only string (e.g. hearing_date "2026-09-09"). Parse explicitly in
		// LOCAL time; `new Date("2026-09-09")` parses as UTC midnight and renders
		// one day earlier in negative-offset timezones (US East Coast).
		date = moment(text, 'YYYY-MM-DD');
	} else {
		// Full timestamps (with time/zone) keep normal parsing.
		date = moment(text);
	}

	let formattedString = date.isValid() ? date.format(format) : '–';

	return <span title={text}>{formattedString}</span>;
}

export default DateFormatter;
